import { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { EffectFade, Thumbs } from "swiper";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Rating from "./sub-components/ProductRating";
import Swiper, { SwiperSlide } from "../swiper";
import { getProductCartQuantity } from "../../helpers/product";
// import { addToCart } from "../../store/slices/cart-slice";
import { addToWishlist } from "../../store/slices/wishlist-slice";
import { addToCompare } from "../../store/slices/compare-slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { addCart, getCartProducts } from "../../store/actions/cart-actions";

function BestProductModal({
  product,
  bestprod,
  currency,
  discountedPrice,
  finalProductPrice,
  finalDiscountedPrice,
  show,
  onHide,
  wishlistItem,
  compareItem,
}) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  // const isLoggedIn = useSelector((state) => state.user.user !== null);
  const isLoggedIn = localStorage.getItem("userauth");
  const [selectedProductColor, setSelectedProductColor] = useState(
    product.color
  );

  const navigate = useNavigate();
  const [quantityCount, setQuantityCount] = useState(1);
  const productCartQty = getProductCartQuantity(
    cartItems,
    product,
    // bestprod,
    selectedProductColor
    // selectedProductSize
  );

  const gallerySwiperParams = {
    spaceBetween: 10,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: { swiper: thumbsSwiper },
    modules: [EffectFade, Thumbs],
  };

  const thumbnailSwiperParams = {
    onSwiper: setThumbsSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: true,
    slideToClickedSlide: true,
    navigation: true,
  };

  const onCloseModal = () => {
    setThumbsSwiper(null);
    onHide();
  };

  const handleAddToCart = () => {
    if (!isLoggedIn) {
      navigate("/login-register"); // Redirect to login if not logged in
      return;
    }


    // // Create the formData object with the necessary fields
    const formData = {
      productId: product._id, // Use the correct product ID
    };
    dispatch(addCart(formData));
    dispatch(getCartProducts());
  };

  const compareItems = useSelector((state) => state.compare.compareItems);

  const handleAddToCompare = () => {
    const alreadyExists = compareItems.some((item) => item._id === product._id);

    if (!alreadyExists) {
      dispatch(addToCompare(product));
    } else {
      alert("Product is already in compare list", { position: "bottom-left" });
    }
  };

  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="product-quickview-modal-wrapper"
    >
      <Modal.Header closeButton></Modal.Header>

      <div className="modal-body" style={{ padding: "2%" }}>
        <div className="row">
          <div className="col-md-5 col-sm-12 col-xs-12">
            {/* Product Image Section */}
            <div
              style={{
                height: "470px",
                width: "100%",
                backgroundColor: "#f9f9f9",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "2px solid #ddd",
                borderRadius: "10px",
                padding: "16px",
                marginBottom: "20px"
              }}
            >
              <img
                src={product?.images?.[0]?.src || product?.seriesImages?.[0]?.src}
                alt="Product"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                  objectPosition: "center"
                }}
                className="img-fluid"
              />
            </div>

            {/* Buttons Section */}
            <div>
              <div
                style={{
                  backgroundColor: "#1c4598",
                  color: "#fff",
                  width: "100%",
                  borderRadius: "5px",
                  textAlign: "center",
                  padding: "12px",
                  marginTop: "10px",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
                onClick={handleAddToCart}
              >
                Add to Cart
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div
                  style={{
                    backgroundColor: "#45B14F",
                    color: "#fff",
                    width: "48%",
                    borderRadius: "5px",
                    textAlign: "center",
                    padding: "12px",
                    marginTop: "10px",
                    fontWeight: "bold",
                    cursor: "pointer"
                  }}
                  onClick={() =>
                    window.open("https://chat.whatsapp.com/KmonIba0CslEpxaSljHbga", "_blank")
                  }
                >
                  Chat on WhatsApp
                </div>

                <div
                  onClick={() => handleAddToCompare(product)}
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    width: "48%",
                    borderRadius: "5px",
                    textAlign: "center",
                    padding: "12px",
                    marginTop: "10px",
                    border: "1px solid #000",
                    fontWeight: "bold",
                    cursor: "pointer"
                  }}
                >
                  Add to Compare
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-7 col-sm-12 col-xs-12">
            <div className="product-details-content quickview-content">
              <h2>{product.name}</h2>
              <div
                className="product-details-price"
                style={{ marginBottom: "10px" }}
              >
                {/* {discountedPrice !== null ? (
                <Fragment>
                  <span>
                    {"₹ "+finalDiscountedPrice}
                  </span>{" "}
                  <span className="old">
                    {"₹ "+finalProductPrice}
                  </span>
                </Fragment>
              ) : (
                <span>{"₹ "+finalProductPrice} </span>
              )} */}
                <span style={{ color: "#000" }}>{"₹ " + product.price}</span>{" "}
                <span className="old">{"₹ " + product.mrp}</span>
              </div>
              <div style={{ backgroundColor: "#F5FBF6" }}>
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                      borderRight: "none",
                      borderBottom: "none",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\SVGRepo_iconCarrier.svg"
                        alt="Description of the image"
                      ></img>
                    </div>
                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      Storage
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      {product?.storage || "0 GB"}
                    </div>
                  </div>
                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                      borderRight: "none",
                      borderBottom: "none",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\vector.svg"
                        alt="Description of the image"
                      ></img>
                    </div>
                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      Colour
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      {" "}
                      {"₹ " + product.color}
                    </div>
                  </div>
                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                      borderRight: "none",
                      borderBottom: "none",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\group.svg"
                        alt="Description of the image"
                      ></img>
                    </div>

                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      Including
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      ------
                    </div>
                  </div>
                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                      borderBottom: "none",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\SVGRepo_iconCarrier (1).svg"
                        alt="Description of the image"
                      ></img>
                    </div>
                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      warranty
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      {product?.warranty || "None"}
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                      borderRight: "none",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\vector (1).svg"
                        alt="Description of the image"
                      ></img>
                    </div>

                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      Condition
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      {product?.cond || "00 %"}
                    </div>
                  </div>
                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                      borderRight: "none",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\group (1).svg"
                        alt="Description of the image"
                      ></img>
                    </div>
                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      Battery
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      {product?.battery || "00 %"}
                    </div>
                  </div>
                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                      borderRight: "none",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\group (2).svg"
                        alt="Description of the image"
                      ></img>
                    </div>
                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      Phone
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      {product?.category || "None"}
                    </div>
                  </div>

                  <div
                    style={{
                      border: "1px solid #E4E8E4",
                      width: "25%",
                      textAlign: "center",
                      justifyItems: "center",
                      padding: "20px 0px",
                    }}
                  >
                    <div
                      style={{
                        width: "34.86px",
                        height: "35px",
                        alignContent: "center",
                      }}
                    >
                      <img
                        src="assets\img\svg\group (3).svg"
                        alt="Description of the image"
                      ></img>
                    </div>
                    <div
                      style={{
                        color: "#212121",
                        fontSize: "14px",
                        margin: "9px 0px 7px",
                      }}
                    >
                      sim
                    </div>
                    <div style={{ color: "#5E5E5E", fontSize: "12px" }}>
                      {product?.simVariant || "None"}
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", marginTop: "25px" }}>
                <div
                  style={{
                    backgroundColor: "#45B14F",
                    padding: "20px",
                    color: "#fff",
                    borderRadius: "2%",
                    width: "49%",
                    marginRight: "2%",
                  }}
                >
                  <div style={{ margin: "0px 0px 21px 0px" }}>
                    <img src="assets\img\svg\good.svg" alt="good"></img>
                  </div>

                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      margin: "0px 0px 10px 0px",
                    }}
                  >
                    GOOD NOTE
                  </div>
                  <div>
                    This device is still covered under the manufacturer's
                    warranty, excluding damage to the back glass.
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "#E9003A",
                    padding: "20px",
                    color: "#fff",
                    borderRadius: "2%",
                    width: "49%",
                  }}
                >
                  <div style={{ margin: "0px 0px 21px 0px" }}>
                    <img src="assets\img\svg\bad.svg" alt="bad" />
                  </div>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      margin: "0px 0px 10px 0px",
                    }}
                  >
                    BAD NOTE
                  </div>
                  <div>
                    This device is still covered under the manufacturer's
                    warranty, excluding damage to the back glass.
                  </div>
                </div>
              </div>
              {/* <div style={{backgroundColor:"#45B14F", width:"10%", padding:"0.5%",textAlign:"center", color:"#fff", borderRadius:"2px"}} >
                4.3 ★
            </div> */}
              {/* {bestprod.rating && bestprod.rating > 0 ? (
              <div className="pro-details-rating-wrap">
                <div className="pro-details-rating">
                  <Rating ratingValue={bestprod.rating} />
                </div>
              </div>
            ) : (
              ""
            )} */}
              {/* <div className="pro-details-list">
                <p dangerouslySetInnerHTML={{ __html: product.about !== "undefined" && product.about !== "" ? product.about : "No data Available" }} />
                
            </div> */}

              {/* {bestprod.variation ? ( */}
              {/* <div className="pro-details-size-color">
                <div className="pro-details-color-wrap">
                  <span>Color</span>
                  <div className="pro-details-color-content">             
                        <label
                          className={`pro-details-color-content--single ${product.color}`}
                          
                        >
                          <input
                            type="radio"
                            value={product.color}
                            name="product-color"
                            checked={
                              product.color === selectedProductColor
                                ? "checked"
                                : ""
                            }
                            onChange={() => {
                              setSelectedProductColor(product.color);
                              // setSelectedProductSize(single.size[0].name);
                              // setProductStock(single.size[0].stock);
                              setQuantityCount(1);
                            }}
                          />
                          <span className="checkmark"></span>
                        </label>
                    {/* })} */}
              {/* </div>
                </div> */}
              {/* <div className="pro-details-size">
                  <span>Size</span>
                  <div className="pro-details-size-content">
                    {product.variation &&
                      product.variation.map(single => {
                        return single.color === selectedProductColor
                          ? single.size.map((singleSize, key) => {
                              return (
                                <label
                                  className={`pro-details-size-content--single`}
                                  key={key}
                                >
                                  <input
                                    type="radio"
                                    value={singleSize.name}
                                    // checked={
                                    //   singleSize.name ===
                                    //   selectedProductSize
                                    //     ? "checked"
                                    //     : ""
                                    // }
                                    onChange={() => {
                                      // setSelectedProductSize(
                                      //   singleSize.name
                                      // );
                                      // setProductStock(singleSize.stock);
                                      setQuantityCount(1);
                                    }}
                                  />
                                  <span className="size-name">
                                    {singleSize.name}
                                  </span>
                                </label>
                              );
                            })
                          : "";
                      })}
                  </div>
                </div> */}
              {/* </div> */}
              {/* ) : ( */}
              {/* "" */}
              {/* )} */}
              {/* {product.affiliateLink ? ( */}
              {/* <div className="pro-details-quality">
                <div className="pro-details-cart btn-hover">
                  {/* <a
                    href={product.affiliateLink}
                    rel="noopener noreferrer"
                    target="_blank"
                  > */}
              {/* Buy Now */}
              {/* </a> */}
              {/* </div>
              </div> */}
              {/* ) : ( */}
              {/* <div className="pro-details-quality">
                {/* <div className="cart-plus-minus">
                  <button
                    onClick={() =>
                      setQuantityCount(
                        quantityCount > 1 ? quantityCount - 1 : 1
                      )
                    }
                    className="dec qtybutton"
                  >
                    -
                  </button>
                  <input
                    className="cart-plus-minus-box"
                    type="text"
                    value={quantityCount}
                    readOnly
                  />
                  <button
                    onClick={() =>
                      setQuantityCount(
                        quantityCount < productStock - productCartQty
                          ? quantityCount + 1
                          : quantityCount
                      )
                    }
                    className="inc qtybutton"
                  >
                    +
                  </button>
                </div> */}
              {/* <div className="pro-details-cart btn-hover">
                  {productStock && productStock > 0 ? (
                    <button
                      // onClick={() =>
                      //   dispatch(addToCart({
                      //     ...product,
                      //     quantity: quantityCount,
                      //     selectedProductColor: selectedProductColor ? selectedProductColor : product.selectedProductColor ? product.selectedProductColor : null,
                      //     // selectedProductSize: selectedProductSize ? selectedProductSize : product.selectedProductSize ? product.selectedProductSize : null
                      //   }))
                      // }
                      // onClick={handleAddToCart}
                      onClick={() => {
                        navigate(`/product/${product._id}`); // Replace with your route
                      }}
                      // style={{borderRadius:"2vh"}}
                      disabled={productCartQty >= productStock}
                    >
                      {" "}
                      Show Full Description{" "}
                    </button>
                  ) : (
                    <button disabled>Out of Stock</button>
                  )}
                </div>
                <div className="pro-details-wishlist">
                  <button
                    className={wishlistItem !== undefined ? "active" : ""}
                    disabled={wishlistItem !== undefined}
                    title={
                      wishlistItem !== undefined
                        ? "Added to wishlist"
                        : "Add to wishlist"
                    }
                    onClick={() => dispatch(addToWishlist(product))}
                  >
                    <i className="pe-7s-like" />
                  </button>
                </div>
                <div className="pro-details-compare">
                  <button
                    className={compareItem !== undefined ? "active" : ""}
                    disabled={compareItem !== undefined}
                    title={
                      compareItem !== undefined
                        ? "Added to compare"
                        : "Add to compare"
                    }
                    onClick={() => dispatch(addToCompare(product))}
                  >
                    <i className="pe-7s-shuffle" />
                  </button>
                </div>
              </div> */}
              {/* )} */}
            </div>
          </div>
          {/* <div style={{padding:"0px"}}>
          <div 
            style={{backgroundColor:"#1c4598", 
                    color:"#fff", 
                    width:"41.67%",
                    borderRadius:"5px",
                    textAlign:"center",
                    padding:"12px",
                    marginTop:"10px"
                    }}>
            Add to cart
          </div>
          <div style={{display:"flex"}} >
            <div 
              style={{backgroundColor:"#45B14F", 
                      color:"#fff", 
                      width:"20%",
                      borderRadius:"5px",
                      textAlign:"center",
                      padding:"12px",
                      marginTop:"10px",
                      marginRight:"1.68%"
                      }}>
              Chat on WhastApp
            </div>
            <div 
              style={{backgroundColor:"#fff", 
                      color:"#000", 
                      width:"20%",
                      borderRadius:"5px",
                      textAlign:"center",
                      padding:"12px",
                      marginTop:"10px",
                      border:"1px solid #000"
                      }}>
              Add to Compare
            </div>
          </div>
        </div> */}
        </div>
      </div>
    </Modal>
  );
}

BestProductModal.propTypes = {
  currency: PropTypes.shape({}),
  discountedprice: PropTypes.number,
  finaldiscountedprice: PropTypes.number,
  finalproductprice: PropTypes.number,
  onHide: PropTypes.func,
  product: PropTypes.shape({}),
  show: PropTypes.bool,
  wishlistItem: PropTypes.shape({}),
  compareItem: PropTypes.shape({}),
};

export default BestProductModal;
